let _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

require('slick-carousel')
require('sweetalert')
require('jquery-modal')
require ('@fancyapps/fancybox')
//require('scrollreveal')
require('./contact')
require('./sliders')
require('./animations')

//COUNTERS
const counter = document.getElementById('counter')
if (counter){
  let a = 0;
  $(window).scroll(function() {
  
    let oTop = $(counter).offset().top - window.innerHeight;
    if (a === 0 && $(window).scrollTop() > oTop) {
      $('.counter-value').each(function() {
        var $this = $(this),
          countTo = $this.attr('data-count');
        $({
          countNum: $this.text()
        }).animate({
            countNum: countTo
          },
          {
            duration: 1300,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum));
            },
            complete: function() {
              $this.text(this.countNum);
              //alert('finished');
            }
          });
      });
      a = 1;
    }
  });
}

//TABS 
const tabs = document.querySelectorAll('[data-tab-target]'),
      tabContents = document.querySelectorAll('[data-tab-content]')

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})

const tabs1 = document.querySelectorAll('[data-tab-target1]'),
tabContents1 = document.querySelectorAll('[data-tab-content1]')

tabs1.forEach(tab => {
  tab.addEventListener('click', () => {
    const target1 = document.querySelector(tab.dataset.tabTarget1)
    tabContents1.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs1.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target1.classList.add('active')
  })
})

const tabs2 = document.querySelectorAll('[data-tab-target2]'),
tabContents2 = document.querySelectorAll('[data-tab-content2]')

tabs2.forEach(tab => {
  tab.addEventListener('click', () => {
    const target2 = document.querySelector(tab.dataset.tabTarget2)
    tabContents2.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs2.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target2.classList.add('active')
  })
})

//MENU MOBILE
const navMenu = document.getElementById('nav-menu'),
  toggleMenu = document.getElementById('nav-toggle'),
  closeMenu = document.getElementById('nav-close')

/*SHOW*/
toggleMenu.addEventListener('click', ()=>{
  navMenu.classList.toggle('show')
  document.body.classList.toggle('lock-screen')
})

/*HIDDEN*/
closeMenu.addEventListener('click', ()=>{
  navMenu.classList.remove('show')
  document.body.classList.toggle('lock-screen')
})

//HIDE ASK IMAGINARY
const askNone = document.getElementById('askNone')
if (askNone && window.matchMedia("(max-width: 800px)").matches)  {
  askNone.remove()
}
//OPEN_FAQ_MODAL
$('a.openFaq').click(function(event) {
  $(this).modal({
    clickClose: true,
    showClose: true,
    fadeDuration: 120
  });
  return false;
});

///DATES
const currentDate = new Date();
const currentDayOfMonth = currentDate.getDate()
const currentMonth = currentDate.getMonth() // Be careful! January is 0, not 1
const currentYear = currentDate.getFullYear()
let dateControl = document.querySelector('#checkIn[type="date"]');
let dateControl2 = document.querySelector('#checkOut[type="date"]');

if (dateControl && dateControl2){
  const dateString = currentYear + "-" + (currentMonth + 1) + "-" + (currentDayOfMonth + 1)
  const dateString2 = currentYear + "-" + (currentMonth + 1) + "-" + (currentDayOfMonth + 2)
  dateControl.min = dateString
  dateControl2.min = dateString2
}